import { useState, useEffect } from 'react';

const useSupplier = ({ vendorOrderModel }) => {
  const [supplierWithoutShipping, setSupplierWithoutShipping] = useState(false);

  const listVendorsId = process.env?.REACT_APP_SUPPLIERS_WITHOUT_SHIPPING?.split(',');

  useEffect(() => {
    if (!vendorOrderModel && !listVendorsId) return;

    const vendorId = vendorOrderModel?.find((vendor) => vendor.vendorId).vendorId;

    if (listVendorsId?.includes(String(vendorId))) {
      setSupplierWithoutShipping(false);
      return;
    }

    setSupplierWithoutShipping(true);
  }, [vendorOrderModel, listVendorsId]);

  return { supplierWithoutShipping };
};

export default useSupplier;
